import React, { useState } from "react";
import { registerWish } from "../../store/actions/user.action";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button } from "@material-tailwind/react";
import { MenuBar } from "../../components/Menu/Menu";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";
import { languages } from "../../components/Transformation/Transformations"

const Wishes = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const mail = localStorage.getItem("mail");
  const [language, setLanguage] = useState("");
  const [day, setDay] = useState("");
  const [note, setNote] = useState("");
  const [interestedTopics, setInterestedTopics] = useState("");
  const [meetingLength, setMeetingLength] = useState("");
  const [time, setTime] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);

  const handleSubmit = (e) => {
    const [hour, minute] = time.split(":");
    if (!token) {
      toast.warn(t("generic.please_login"), {position: "bottom-right",});
      return;
    }
    if (!language || !day || !hour || !minute || !meetingLength) {
      toast.warn(t("generic.enter_all"), {
        position: "bottom-right",
      });
      return;
    }
    dispatch(
      registerWish({
        language,
        day,
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        timezone: currentUser?.timezone,
        meetingLength: parseInt(meetingLength, 10),
        interestedTopics,
        note,
        token,
        mail,
        owner: currentUser?.results?.[0]?.id,
      })
    );
    setLanguage("");
    setDay("");
    setInterestedTopics("");
    setMeetingLength("");
    setNote("");
    setTime("");
    navigate("/schedule-meeting");
  };
  const openMenuBar = () => {
    setMenuOpen(true);
  };
  const closeMenuBar = () => {
    setMenuOpen(false);
  };

  return (
    <div>
      <Header openMenu={openMenuBar} />
      <div className="max-w-[1120px] mx-auto px-6 py-16">
        <div className="flex justify-center mb-8">
          <p className="leading-relaxed font-semibold text-base text-[var(--brand)] italic w-fit py-2 px-5 border-l-4 border-r-4 border-x-[var(--brand)] bg-[#EEF2FF] rounded-[var(--radius)] shadow-[var(--shadow-sm)]">
            {t("wish.title")}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div>
            <img className="w-full rounded-[var(--radius)]" src={"https://res.cloudinary.com/do6t8sxgo/image/upload/v1724620287/Wish_tc7n4x.png"} alt="WishImage" />
          </div>
          <div>
            <div className="bg-white shadow-[var(--shadow)] rounded-[var(--radius)] border border-[var(--border)] p-8">
              <h2 className="text-xl font-bold text-[var(--text)] mb-6">{t("wish.form")}</h2>
              <form>
                <div className="mb-4">
                  <label htmlFor="language" className="block text-sm font-medium text-[var(--text)] mb-2">
                    {t("wish.lang")}
                  </label>
                  <select
                    required
                    id="language"
                    className="w-full px-3 py-2.5 border border-[var(--border)] rounded-lg text-sm focus:ring-[var(--brand)] focus:border-[var(--brand)]"
                    onChange={(e) => setLanguage(e.target.value)}
                    value={language}
                  >
                    <option value="">{t("wish.choose")}</option>
                    {languages.map((language) => (
                      <option key={language.value} value={language.value}>
                        {t(language.label)}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="mb-4">
                  <label htmlFor="dayOfWeek" className="block text-sm font-medium text-[var(--text)] mb-2">
                    {t("wish.week_day")}
                  </label>
                  <select
                    required
                    id="dayOfWeek"
                    className="w-full px-3 py-2.5 border border-[var(--border)] rounded-lg text-sm focus:ring-[var(--brand)] focus:border-[var(--brand)]"
                    onChange={(e) => setDay(e.target.value)}
                    value={day}
                  >
                    <option value="">{t("wish.choose_week_day")}</option>
                    <option value="Mon">{t("generic.mon")}</option>
                    <option value="Tue">{t("generic.tue")}</option>
                    <option value="Wed">{t("generic.wed")}</option>
                    <option value="Thu">{t("generic.thu")}</option>
                    <option value="Fri">{t("generic.fri")}</option>
                    <option value="Sat">{t("generic.sat")}</option>
                    <option value="Sun">{t("generic.sun")}</option>
                  </select>
                </div>
                <div className="mb-4">
                  <label htmlFor="meetingTime" className="block text-sm font-medium text-[var(--text)] mb-2">
                    {t("wish.time")}
                  </label>
                  <input
                    type="time"
                    id="meetingTime"
                    value={time}
                    className="w-full px-3 py-2.5 border border-[var(--border)] rounded-lg text-sm focus:ring-[var(--brand)] focus:border-[var(--brand)]"
                    onChange={(e) => setTime(e.target.value)}
                  />
                </div>
                <div className="mb-4">
                  <label htmlFor="meetingLength" className="block text-sm font-medium text-[var(--text)] mb-2">
                    {t("wish.length")}
                  </label>
                  <select
                    id="meetingLength"
                    className="w-full px-3 py-2.5 border border-[var(--border)] rounded-lg text-sm focus:ring-[var(--brand)] focus:border-[var(--brand)]"
                    value={meetingLength}
                    onChange={(e) => setMeetingLength(e.target.value)}
                  >
                    <option value="">{t("wish.choose_length")}</option>
                    <option value="15">15</option>
                    <option value="30">30</option>
                    <option value="45">45</option>
                    <option value="60">60</option>
                  </select>
                </div>
                <div className="mb-4">
                  <label htmlFor="interestedTopic" className="block text-sm font-medium text-[var(--text)] mb-2">
                    {t("wish.topic")}
                  </label>
                  <input
                    type="text"
                    id="interestedTopic"
                    className="w-full px-3 py-2.5 border border-[var(--border)] rounded-lg text-sm focus:ring-[var(--brand)] focus:border-[var(--brand)]"
                    placeholder={t("wish.choose_topic")}
                    value={interestedTopics}
                    onChange={(e) => setInterestedTopics(e.target.value)}
                  />
                </div>
                <div className="mb-6">
                  <label htmlFor="note" className="block text-sm font-medium text-[var(--text)] mb-2">
                    {t("wish.note")}
                  </label>
                  <textarea
                    id="note"
                    className="w-full px-3 py-2.5 border border-[var(--border)] rounded-lg text-sm focus:ring-[var(--brand)] focus:border-[var(--brand)]"
                    placeholder={t("wish.input_note")}
                    rows="4"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                  ></textarea>
                </div>
                <div className="text-right">
                  <Button
                    variant="gradient"
                    color="purple"
                    onClick={() => handleSubmit()}
                  >
                    <span>{t("wish.submit")}</span>
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <MenuBar open={menuOpen} close={closeMenuBar} />
    </div>
  );
};

export default Wishes;
